import { isSameId } from "../../helpers";
export default function (store, { id }) {
    const stateSelected = store.getState().selected;
    if (stateSelected) {
        store.in.exec("set-edit", null);
        if (!id) {
            store.setState({ selected: null });
            return;
        }
        const selected = stateSelected.filter(selectedId => !isSameId(selectedId, id));
        store.setState({ selected });
    }
}
//# sourceMappingURL=unselect.js.map